import { Modal } from 'react-bootstrap'

export default function CampaignConfirmation({ show, onClose, campaign, onSubmitApproval }) {

    const acceptCampaign = () => {
        onSubmitApproval(campaign, true)
        onClose();
    };

    const cancelAction = () => {
        onClose();
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            className="moddal-width companyEdit-modal ps-0 add-modal"
        >
            <div className="modal-header pt-2">
                <button
                    type="button"
                    className="btn-close text-dark close-button"
                    onClick={onClose}
                >
                    &nbsp;
                </button>
            </div>

            <div className="modal-body pb-0">
                <div className="row">
                    <div className="col-12 text-center mb-3">
                        <h5 className="mb-2">Campaign review request</h5>
                        <p className="mb-0">
                            Please review the campaign details carefully.
                            Click <strong>Confirm</strong> to approve the campaign.
                        </p>
                    </div>

                    <div className="row">
                        <div className="col-md-3"></div>

                        <div className="col-md-3 cancelbox">
                            <button
                                type="button"
                                onClick={cancelAction}
                                className="btn save-btn confirm m-0"
                            >
                                Cancel
                            </button>
                        </div>

                        <div className="col-md-3">
                            <button
                                className="btn save-btn cancel m-0"
                                onClick={acceptCampaign}
                                type="button"
                            >
                                Confirm
                            </button>
                        </div>

                        <div className="col-md-3"></div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
